import { functions } from '@/firebase'

export default {
  sendPlataforma({ }, payload) {
    var promesa = functions.httpsCallable('httpSoporteSendPlataforma');
    return promesa(payload)
  }
}